import { Position } from 'src/types/position';

export const mimes = {
  SVG: 'image/svg+xml',
};

export const GIPHY = 'GIPHY';

// for Files module use only FOLDER and FILE.
export enum FileTypes {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  FILE = 'FILE',
  AUDIO = 'AUDIO',
  GIF = 'GIF',
  FOLDER = 'FOLDER',
}

export type AttachmentsSplit = {
  videos: Attachment[];
  images: Attachment[];
  files: Attachment[];
};

export type Attachment = {
  id?: number;
  url: string;
  externalReference?: {
    id: string;
    origin: string;
  };
  type: FileTypes;
  position: number | null;
  height: number | null;
  width: number | null;
  size: string | null;
  name: string | null;
  thumbnailUrl?: string;
  lastModified?: number;
};

export type FormFile = Partial<Position> & {
  name: string | null;
  url?: string;
  size: number | null;
  mime: string;
  fileObject: File | null;
  type: string;
  toUpload?: boolean;
  height?: number;
  width?: number;
};

// Response
export type SignedUrlResponse = {
  url: string;
};
